import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import EventPage from './Events/EventPage';
import NewsPage from './News/NewsPage';
import FilesPage from './Files/FilesPage';
import HighlightPage from './Highlight/HighlightPage';
import DatePage from './Date/DatePage';
import './BasseCour.scss';
import PillsPage from './Pills/PillsPage';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (

    <MainLayout scope={'quatrebis'} websiteLabel={"le4bis-ij.com"}>
      <EventPage isActive={navigationContext.activeAppKey === 'qbevent'} />
      <NewsPage isActive={navigationContext.activeAppKey === 'qbnews'} />
      <HighlightPage isActive={navigationContext.activeAppKey === 'qbhighlight'} />
      <DatePage isActive={navigationContext.activeAppKey === 'qbdate'} />
      <FilesPage isActive={navigationContext.activeAppKey === 'qbfiles'} />
      <PillsPage isActive={navigationContext.activeAppKey === 'qbpills'} />
    </MainLayout>
  );
}

export default Home;
